import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useOutstandingInvoiceList = ({ search, page, pageSize }) => {
  const filter = {
    filter: { searchTerm: search },
    paging: { pageIndex: page },
  };

  return useQuery({
    queryKey: ["unpaidInvoiceListState", filter],
    // enabled: true,
    queryFn: async () =>
      callApi({
        path: "unpaidInvoiceList",
        command: "",
        data: JSON.stringify({ list: filter }),
      }),
    placeholderData: keepPreviousData,
    staleTime: 5000,
  });
};
